import React from 'react';
import PropTypes from 'prop-types';

import { MUIModal } from 'Components/Base';

import ClearExitConfirmationContent from './ClearExitConfirmationContent';

const ClearExitConfirmationModal = ({ onConfirm, onCancel, muiProps, ...props }) => {
  const { isActive, toggleComponent, onOpen, onClose } = muiProps;
  return (
    <MUIModal
      isOpen={isActive}
      toggleComponent={toggleComponent}
      onOpenModal={onOpen}
      onCloseModal={onClose}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '343px', height: '410px' }}
      innerProps={{ height: '100%' }}
      closeIcon={false}
      disableBackdropClick
      {...props}
    >
      <ClearExitConfirmationContent onConfirm={onConfirm} onCancel={onCancel} />
    </MUIModal>
  );
};

ClearExitConfirmationModal.propTypes = {
  muiProps: PropTypes.shape({
    toggleComponent: PropTypes.element,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isActive: PropTypes.bool,
  }),
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ClearExitConfirmationModal;
